import { defineMessages } from 'react-intl';

export const billingPoliciesMessages = defineMessages({
    billingPolicies: {
        id: 'billing-policies',
        defaultMessage: 'Billing policies',
    },
    policies: {
        id: 'policies',
        defaultMessage: 'Policies',
    },
    policy: {
        id: 'policy',
        defaultMessage: 'Policy',
    },
    billingCycle: {
        id: 'billing-cycle',
        defaultMessage: 'Billing cycle',
    },
    billingTime: {
        id: 'billing-time',
        defaultMessage: 'Billing time',
    },
    measurement: {
        id: 'measurement',
        defaultMessage: 'Measurement',
    },
    enabledProrate: {
        id: 'enabled-prorate',
        defaultMessage: 'Enabled prorate',
    },
    createServicePlanBillingPolicySuccess: {
        id: 'create-service-plan-billing-policy-success',
        defaultMessage: 'Service plan billing policy created',
    },
    createServicePlanBillingPolicySuccessDescription: {
        id: 'create-service-plan-billing-policy-success-description',
        defaultMessage: 'A service plan billing policy has been successfully created.',
    },
    addServicePlanBillingPolicySubtitle: {
        id: 'add-service-plan-billing-policy-subtitle',
        defaultMessage: 'Create a new service plan billing policy',
    },
    statefulBillingStrategy: {
        id: 'stateful-billing-strategy',
        defaultMessage: 'Stateful billing strategy',
    },
    oneTime: {
        id: 'one-time',
        defaultMessage: 'One time',
    },
    monthly: {
        id: 'monthly',
        defaultMessage: 'Monthly',
    },
    quarterly: {
        id: 'quarterly',
        defaultMessage: 'Quarterly',
    },
    semiannually: {
        id: 'semiannually',
        defaultMessage: 'Semiannually',
    },
    yearly: {
        id: 'yearly',
        defaultMessage: 'Yearly',
    },
    anniversary: {
        id: 'anniversary',
        defaultMessage: 'Anniversary',
    },
    stateful: {
        id: 'stateful',
        defaultMessage: 'Stateful',
    },
    metered: {
        id: 'metered',
        defaultMessage: 'Metered',
    },
    timeWeighted: {
        id: 'time-weighted',
        defaultMessage: 'Time weighted',
    },
    endOfPeriod: {
        id: 'end-of-period',
        defaultMessage: 'End of period',
    },
    maxInPeriod: {
        id: 'max-in-period',
        defaultMessage: 'Max in period',
    },
    sum: {
        id: 'sum',
        defaultMessage: 'Sum',
    },
    max: {
        id: 'max',
        defaultMessage: 'Max',
    },
    last: {
        id: 'last',
        defaultMessage: 'Last',
    },
    meteredBillingStrategy: {
        id: 'metered-billing-strategy',
        defaultMessage: 'Metered billing strategy',
    },
    current: {
        id: 'current',
        defaultMessage: 'Current',
    },
    past: {
        id: 'past',
        defaultMessage: 'Past',
    },
    scheduled: {
        id: 'scheduled',
        defaultMessage: 'Scheduled',
    },
    deleteServicePlanBillingPolicy: {
        id: 'delete-service-plan-billing-policy',
        defaultMessage: 'Delete billing policy',
    },
    deleteServicePlanBillingPolicySuccess: {
        id: 'delete-service-plan-billing-policy-success',
        defaultMessage: 'Billing policy deleted',
    },
    deleteServicePlanBillingPolicySuccessDescription: {
        id: 'delete-service-plan-billing-policy-success-description',
        defaultMessage: 'The service plan billing policy has been successfully deleted.',
    },
    confirmDeleteServicePlanBillingPolicy: {
        id: 'confirm-delete-service-plan-billing-policy',
        defaultMessage:
            'Are you sure you want to delete this service plan billing policy? This action cannot be undone.',
    },
    deleteServicePlanBillingPolicySubtitle: {
        id: 'delete-service-plan-billing-policy-subtitle',
        defaultMessage: 'Permanently delete service plan billing policy',
    },
    editServicePlanBillingPolicySubtitle: {
        id: 'edit-service-plan-billing-policy-subtitle',
        defaultMessage: 'Edit billing policy',
    },
    updateServicePlanBillingPolicySuccess: {
        id: 'update-service-plan-billing-policy-success',
        defaultMessage: 'Billing policy updated',
    },
    updateServicePlanBillingPolicySuccessDescription: {
        id: 'update-service-plan-billing-policy-success-description',
        defaultMessage: 'Service plan billing policy has been successfully updated.',
    },
    regular: {
        id: 'regular',
        defaultMessage: 'Regular',
    },
    custom: {
        id: 'custom',
        defaultMessage: 'Custom',
    },
    bank: {
        id: 'bank',
        defaultMessage: 'Bank',
    },
    lastScheduledBillingPolicyError: {
        id: 'custom-error:delete_not_last_service_plan_item_billing_policy',
        defaultMessage: 'Only the last scheduled service plan item billing policy can be deleted!',
    },
});
